module.exports = __webpack_public_path__ + "static/img/2652_phase_function_Paper_Points.ba5de95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2652_phase_function_Paper_Points.png
// module id = X+PW
// module chunks = 0